export default __webpack_public_path__ + "static/media/0115.8111abbd.png";